import { render } from "./editInformations.vue?vue&type=template&id=21601896&scoped=true"
import script from "./editInformations.vue?vue&type=script&lang=js"
export * from "./editInformations.vue?vue&type=script&lang=js"

import "./editInformations.vue?vue&type=style&index=0&id=21601896&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21601896"]])

export default __exports__